import { api } from '../api';

/**
 * 管理者用：ユーザー管理API
 */
const userManagementApi = {
  /**
   * 新規ユーザーを作成する
   * @param {Object} userData ユーザーデータ
   * @returns {Promise} 作成されたユーザー情報
   */
  createUser: async (userData) => {
    const response = await api.post('/admin/users/', userData);
    return response.data;
  },

  /**
   * 全ユーザーリストを取得する
   * @returns {Promise} ユーザーリスト
   */
  getUsers: async () => {
    const response = await api.get('/admin/users/');
    return response.data;
  },

  /**
   * ユーザー情報を更新する
   * @param {string} userId ユーザーID
   * @param {Object} userData 更新するユーザーデータ
   * @returns {Promise} 更新されたユーザー情報
   */
  updateUser: async (userId, userData) => {
    const response = await api.put(`/admin/users/${userId}`, userData);
    return response.data;
  },
  
  /**
   * ユーザーを削除する
   * @param {string} userId ユーザーID
   * @returns {Promise} 削除結果
   */
  deleteUser: async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  }
};

export default userManagementApi;